module.exports = __webpack_public_path__ + "static/architecture-63b6ec3e18279d3fe5f1a49bb65f68e4.png";